import { useQuery } from "@apollo/client"
import { client } from "../../graphql/contentful/client"
import { gql } from "@apollo/client"

export const QUERY_HOME_PAGE_IMAGE_COLLECTION = gql`
  query getAllHomePageImages {
    homePageContentCollection {
      items {
        heroImage {
          url(transform: { width: 2400, quality: 70 })
        }
      }
    }
  }
`

export const useHomePageImageCollection = () => {
  const { data, error, loading, refetch } = useQuery(QUERY_HOME_PAGE_IMAGE_COLLECTION, {
    client: client,
  })
  return {
    homePageContentCollection: data?.homePageContentCollection,
    homeContentError: error,
    homeContentLoading: loading,
    refetch,
  }
}
